import { render } from "./AccessLogs.vue?vue&type=template&id=b7f1cd44&scoped=true"
import script from "./AccessLogs.vue?vue&type=script&lang=ts"
export * from "./AccessLogs.vue?vue&type=script&lang=ts"

import "./AccessLogs.vue?vue&type=style&index=0&id=b7f1cd44&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b7f1cd44"

export default script